import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(() => ({
  root: {
    marginTop: 20
  },
  loader: {
    justifyContent: 'center',
    display: 'flex',
    paddingTop: 20
  },
  penaltyOnPaymentTerm: {
    '& :hover': {
      cursor: 'pointer'
    },
    alignItems: 'center',
    justifyContent: 'center',
    display: 'flex'
  }
}));
